.atm_bx_15xxhlz.atm_bx_15xxhlz{font-family:'DM Sans',sans-serif;}
.atm_g3_bs82vp.atm_g3_bs82vp{line-height:1.5;}
.atm_gi_idpfg4{margin:0;}
.atm_c8_1j6vyhq.atm_c8_1j6vyhq{font-size:1rem;}
.atm_c8_1x7uoys.atm_c8_1x7uoys{font-size:0.875rem;}
.atm_c8_1jaf4fe.atm_c8_1jaf4fe{font-size:0.75rem;}
.atm_c8_1kw7nm4.atm_c8_1kw7nm4{font-size:inherit;}
.atm_cs_4jg895.atm_cs_4jg895{font-weight:normal;}
.atm_cs_bfngof.atm_cs_bfngof{font-weight:500;}
.atm_cs_1fw03zg.atm_cs_1fw03zg{font-weight:700;}
.atm_cs_1kw7nm4.atm_cs_1kw7nm4{font-weight:inherit;}
